import _ from 'underscore';
import Renewal from 'gw-portals-renewal-js/models/Renewal';

export default (function (q, RenewalService, RenewalJobService, AvailabilityService, TranslateService, ViewModelService, UserInfoService, paymentType) {

    var translateFn = TranslateService.instant;

    var createViewModel = function createViewModel(model) {
        return ViewModelService.create(new Renewal(model), 'pc', 'edge.capabilities.renewal.dto.RenewalDataDTO');
    };

    var ACTIONS = {
        save: function save(model) {
            return RenewalService.saveRenewal(model.value).then(createViewModel);
        },
        generateQuote: function generateQuote(model) {
            return RenewalService.isQuoted(model.jobID.value).then(function (isQuoted) {
                if (isQuoted) {
                    return q.resolve(model);
                }
                delete model.value.bindData;
                return RenewalService.generateQuote(model.value).then(createViewModel);
            });
        },
        retrievePaymentPlans: function retrievePaymentPlans(_ref) {
            var model = _ref.value;
            return RenewalService.retrievePaymentPlans(model.jobID).then(function (paymentPlanDTOs) {
                model.bindData.chosenQuote = model.quoteData.offeredQuotes[0].publicID;
                model.bindData.paymentPlans = paymentPlanDTOs;
                model.bindData.paymentDetails = {
                    paymentMethod: paymentType.WIRE,
                    creditCardData: {},
                    bankAccountData: {}
                };
                return ViewModelService.create(model, 'pc', 'edge.capabilities.renewal.dto.RenewalDataDTO');
            });
        },
        bind: function bind(model) {
            return RenewalService.bind(model.value).then(createViewModel);
        },
        refer: function refer(model, args) {
            return RenewalService.updatePaymentPlan(model.value).then(function () {
                var note = args[0].value;
                return RenewalJobService.referToUnderwriter(model.jobID.value, note).then(function () {
                    return model;
                });
            });
        }
    };

    var ACTION_MSG = {
        save: {
            error: {
                title: 'gw-portals-policytransaction-renewal-bop-angular.config.FlowConfig.Unable to save',
                message: 'gw-portals-policytransaction-renewal-bop-angular.config.FlowConfig.An error occurred while attempting to save.'
            }
        },
        generateQuote: {
            error: {
                title: 'gw-portals-policytransaction-renewal-bop-angular.config.FlowConfig.Unable to quote',
                message: 'gw-portals-policytransaction-renewal-bop-angular.config.FlowConfig.An error occurred while attempting to quote.'
            }
        },
        retrievePaymentPlans: {
            error: {
                title: 'gw-portals-policytransaction-renewal-bop-angular.config.FlowConfig.Unable to retrieve payment plans',
                message: 'gw-portals-policytransaction-renewal-bop-angular.config.FlowConfig.An error occurred while attempting to retrieve payment plans.'
            },
            progress: {
                message: 'gw-portals-policytransaction-renewal-bop-angular.config.FlowConfig.Retrieving payment plans...'
            }
        },
        bind: {
            error: {
                title: 'gw-portals-policytransaction-renewal-bop-angular.config.FlowConfig.Unable to purchase renewal',
                message: 'gw-portals-policytransaction-renewal-bop-angular.config.FlowConfig.An error occurred while attempting to bind your renewal'
            },
            progress: {
                message: 'gw-portals-policytransaction-renewal-bop-angular.config.FlowConfig.Processing Payment...'
            }
        },
        refer: {
            error: {
                title: 'gw-portals-policytransaction-renewal-bop-angular.config.FlowConfig.Unable to refer renewal',
                message: 'gw-portals-policytransaction-renewal-bop-angular.config.FlowConfig.An error occurred while attempting to refer your renewal'
            },
            progress: {
                message: 'gw-portals-policytransaction-renewal-bop-angular.config.FlowConfig.Processing...'
            }
        }
    };

    return function (step, junction) {

        step('renewalBopPolicyDetails', true).skipOnResumeIf(function () {
            return true;
        }).onNext.doAction(ACTIONS.save, ACTION_MSG.save).thenGoTo('renewalBopGeneralCoverages', 'transactionError').label(function () {
            return translateFn('gw-portals-policytransaction-renewal-bop-angular.config.FlowConfig.Policy Details');
        });

        step('renewalBopGeneralCoverages').onNext.goTo('renewalBopAdditionalCoverages').skipOnResumeIf(function (_ref2) {
            var model = _ref2.value;

            var coverages = model.lobData.businessOwners.coverages.lobCoverages;
            return model.baseData.periodStatus === 'Quoted' || coverages && !_.findWhere(coverages, { isValid: false });
        }).label(function () {
            return translateFn('gw-portals-policytransaction-renewal-bop-angular.config.FlowConfig.General Coverages');
        });

        step('renewalBopAdditionalCoverages').onNext.goTo('renewalBopLocationsAndBuildings').skipOnResumeIf(function (_ref3) {
            var model = _ref3.value;

            var coverages = model.lobData.businessOwners.coverages.additionalCoverages;
            return model.baseData.periodStatus === 'Quoted' || coverages && !_.findWhere(coverages, { isValid: false });
        }).label(function () {
            return translateFn('gw-portals-policytransaction-renewal-bop-angular.config.FlowConfig.Additional Coverages');
        });

        step('renewalBopLocationsAndBuildings').skipOnResumeIf(function (_ref4) {
            var model = _ref4.value;

            return model.baseData.periodStatus === 'Quoted';
        }).onNext.doAction(ACTIONS.generateQuote, ACTION_MSG.generateQuote).thenGoTo('renewalBopQuote', 'transactionError').label(function () {
            return translateFn('gw-portals-policytransaction-renewal-bop-angular.config.FlowConfig.Locations and Buildings');
        });

        step('renewalBopQuote').onNext.goTo('renewalBopLoadPaymentPlans').label(function () {
            return translateFn('gw-portals-policytransaction-renewal-bop-angular.config.FlowConfig.Quote');
        });

        junction('renewalBopLoadPaymentPlans').onNext.doAction(ACTIONS.retrievePaymentPlans, ACTION_MSG.retrievePaymentPlans).thenGoTo('renewalBopPaymentDetails', 'transactionError');

        step('renewalBopPaymentDetails').onNext.branch(function () {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return args[1].length > 0 ? 'renewalBopRefer' : 'renewalBopBind';
        }).label(function () {
            return translateFn('gw-portals-policytransaction-renewal-bop-angular.config.FlowConfig.Payment Details');
        });

        junction('renewalBopBind').onNext.doAction(ACTIONS.bind, ACTION_MSG.bind).thenGoTo('confirmation', 'error');

        junction('renewalBopRefer').onNext.doAction(ACTIONS.refer, ACTION_MSG.refer).thenGoTo('returnHome', 'error');
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/conditional?if=endorsement-products&equals=BusinessOwners!./common/js/src/edge/gw-portals-policytransaction-renewal-bop-angular/config/FlowConfig.js
// module id = 436
// module chunks = 0